<template>
  <article :id="elementId" class="novidades-improvement-card">
    <div class="novidades-improvement-card__head">
      <div class="novidades-improvement-card__title-row">
        <span aria-hidden="true">{{ improvement.emoji || "✨" }}</span>
        <h3 class="novidades-improvement-card__title">
          {{ improvement.title }}
        </h3>
      </div>
      <span
        v-if="improvement.category"
        class="novidades-improvement-card__category"
      >
        {{ improvement.category }}
      </span>
    </div>

    <p
      v-if="improvement.description"
      class="novidades-improvement-card__description"
    >
      {{ improvement.description }}
    </p>

    <ImprovementPreviewWidget :improvement="improvement" />

    <div
      v-if="improvement.articleUrl || improvement.actionUrl"
      class="novidades-improvement-card__links"
    >
      <a
        v-if="improvement.articleUrl"
        :href="improvement.articleUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="novidades-improvement-card__link"
      >
        <v-icon x-small class="mr-1">fas fa-book-open</v-icon>
        {{
          improvement.articleText || "Acessar Artigo na Base de Conhecimento"
        }}
        <v-icon x-small class="ml-1">fas fa-external-link-alt</v-icon>
      </a>
      <a
        v-if="improvement.actionUrl"
        :href="improvement.actionUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="novidades-improvement-card__link novidades-improvement-card__link--blue"
      >
        <v-icon x-small class="mr-1">far fa-question-circle</v-icon>
        {{ improvement.actionText || "Falar com suporte para configuração" }}
        <v-icon x-small class="ml-1">fas fa-external-link-alt</v-icon>
      </a>
    </div>
  </article>
</template>

<script>
import ImprovementPreviewWidget from "./ImprovementPreviewWidget";

export default {
  name: "ImprovementCard",
  components: { ImprovementPreviewWidget },
  props: {
    improvement: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    elementId() {
      return `novidade-item-${this.index}`;
    }
  }
};
</script>
